import './listing-preview.css';

import { IListing } from '../models/listing.model';
import { formatNumber } from '../util/format-number';
import { ListingPreviewHighlights } from './listing-preview-highlights/listing-preview-highlights';
import ListingLink from '../listing-link/listing-link';
import { useCallback, useMemo } from 'react';
import { iconBookmark, iconBookmarkSolid } from '../util/icons';
import { formatListingCommunityName, formatListingType } from '../util/format-listing-strings';

export interface ListingPreviewProps {
  listing: IListing;
  isSavedListing(value: string): boolean;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
}

export const ListingPreview = (props: ListingPreviewProps) => {

  const addSavedListing = useCallback(function (e: React.MouseEvent<HTMLElement>, value: IListing) {
    e.preventDefault();
    props.addSavedListing(value);
    e.stopPropagation();
  }, [props]);

  const removeSavedListing = useCallback(function (e: React.MouseEvent<HTMLElement>, value: IListing) {
    e.preventDefault();
    props.removeSavedListing(value);
    e.stopPropagation();
  }, [props]);

  const favButton = useMemo(() => props.isSavedListing(props.listing.id)
    ? <button className="bookmark-icon" onClick={e => removeSavedListing(e, props.listing)}>{iconBookmarkSolid}</button>
    : <button className="bookmark-icon" onClick={e => addSavedListing(e, props.listing)} >{iconBookmark}</button>,
    [addSavedListing, props, removeSavedListing]);

  const listingTypeText = useMemo(() => formatListingType(props.listing), [props.listing]);
  const communityText = useMemo(() => formatListingCommunityName(props.listing), [props.listing]);

  return (
    <div className="listing-preview">
      <ListingLink listing={props.listing}>
        <div className="listing-preview-picture">
          {props.listing.listingPhotos.length > 0 && props.listing.listingPhotos[0].url !== "" &&
            <img loading="lazy" src={props.listing.listingPhotos[0].url} alt={props.listing.listingPhotos[0].description} />
          }
        </div>
        <div className="listing-preview-data">
          <div className="listing-preview-actions">
            {favButton}
          </div>
          <div className="listing-preview-data-price">
            ${formatNumber(props.listing.price, 0)}
          </div>
          <div className="listing-preview-address">
            {props.listing.address}
          </div>
          <div className="listing-community">{communityText}</div>
          <div className="listing-type">{listingTypeText}</div>
          <ListingPreviewHighlights listing={props.listing} showDescription />
        </div>
      </ListingLink>
    </div>
  );
}

export default ListingPreview;
